<template>
  <div class="not-prose static" >

    <div v-if="showForm" class="lg:px-8 md:pt-4">
      <property-search-form
        :terms="terms"
        class="relative z-30 bg-gray-100 dark:bg-primary p-3"
        @submitted="performSearch"
      ></property-search-form>
    </div>

    <div v-if="showMeta && meta.total" class="lg:px-8">
      <div
        class="bg-gray-100 dark:bg-primary flex flex-wrap md:items-center"
        :class="{
          'px-3 pb-3': showForm,
          'p-3': !showForm
        }"
      >

        <search-filters
          v-if="typeFilter || areaFilter"
          :type-filter="typeFilter"
          :area-filter="areaFilter"
          class="w-full md:w-auto md:order-3 gl-flex-grow xl:flex-shrink pb-3 md:pb-0 md:pl-3"
          :terms="params"
          @filtered="performFilter"
        ></search-filters>

        <p class="w-1/2 md:w-auto text-gray-700 dark:text-gray-300 px-3 py-2 grow md:order-1 flex items-center" tabindex="0">
          <span v-if="meta.total > 0" >
            Showing {{ meta.total }} results
          </span>
        </p>

        <div class="w-1/2 md:w-auto md:order-2" >
          <a
            href="/account/"
            class="form-button text-gray-100/75 hover:text-gray-100/100 h-10 border border-primary-dark px-4 bg-primary-dark/50 hover:bg-primary-dark/100 flex items-center justify-center whitespace-nowrap"
            target="_blank"
          >Favorites ({{ numFavorites }})</a>
        </div>

      </div>
    </div>

    <div class="lg:px-8 pb-12 lg:pb-28 flex flex-wrap">
      <div class="w-full md:w-auto flex-grow bg-primary shadow-lg" >
        <div class="w-full h-96 md:h-[700px]" >

          <div v-if="!noresults && !loading" class="relative z-20 flex h-full" >
            <map-search-map
              :long="-85.00548639994183"
              :lat="29.798976069691676"
              :zoom="10"
              class="relative w-full h-full"
              tabindex="0"
              :geojson="geojson"
              :show-areas="showAreas"
              @areaclicked="filterArea"
              @listingclicked="setActiveListing"
            ></map-search-map>
          </div>

          <div v-else class="py-4 m-0 text-center flex items-center justify-center lg:py-8 h-full">
            <div v-if="loading" class="flex items-center space-x-6 opacity-60 text-primary dark:text-white">
              <svg-vue icon="home" class="h-6 w-6 fill-current animate-spin" ></svg-vue>
              <p class="font-bold" >Loading Results...</p>
            </div>
            <slot v-else />
          </div>

        </div>
      </div>

    </div>

    <teleport to="#popup-target">
      <div v-if="activeMls.rets_listing_id" class="w-full h-screen bg-primary-dark/90 dark:backdrop-blur-xl p-8 shadow-lg fixed top-0 left-0 z-[800] flex flex-col justify-center items-center" >
        <listing-card
          :listing="activeMls"
          :logged-in="loggedIn"
          :user="user"
          class="w-full md:w-[300px]"
          @set-favorite="updateFavorites"
        ></listing-card>
        <button @click="activeMls = {}" class="form-button text-white bg-primary-dark/50 hover:bg-primary-dark/100 h-10 px-4 flex items-center mt-6 uppercase border" >
          Back to Map
        </button>
      </div>
    </teleport>

  </div>
</template>
<script>
import PropertySearchForm from './PropertySearchForm.vue'
import SearchFilters from './SearchFilters.vue'
import ListingCard from './ListingCard.vue'
import MapSearchMap from './MapSearchMap.vue'

export default {
  name: "MapSearch",

  props: {
    showForm: {
      type: Boolean,
      default: true
    },
    showMeta: {
      type: Boolean,
      default: true
    },
    typeFilter: {
      type: Boolean,
      default: false
    },
    areaFilter: {
      type: Boolean,
      default: false
    },
    terms: {
      type: Object,
      default: () => {}
    },
    loggedIn: {
      type: Boolean,
      default: false
    },
    user: {
      type: Number,
      default: null
    },
  },

  data () {
    return {
      endpoint: 'https://rets.kerigan.com/api/v2/mapsearch',
      loading: false,
      showAreas: true,
      showSort: false,
      geojson: {
        type: "FeatureCollection",
        features: [
          {
            geometry: { coordinates: [-85.30274474596409, 29.81821079485716], type: "Point" },
            properties: { title: "Port St. Joe", type: "area", name: "Port St. Joe" }, type: "Feature"
          },
          {
            geometry: { coordinates: [-85.39381522419906, 29.744199067611437], type: "Point" },
            properties: { title: "N. Cape San Blas", type: "area", name: "Cape San Blas-N" }, type: "Feature"
          },
          {
            geometry: { coordinates: [-85.34910978146294, 29.674171758173593], type: "Point" },
            properties: { title: "S. Cape San Blas", type: "area", name: "Cape San Blas-S" }, type: "Feature"
          },
          {
            geometry: { coordinates: [-85.30366714164445, 29.720172899469414], type: "Point" },
            properties: { title: "SR 30-A", type: "area", name: "SR 30-A" }, type: "Feature"
          },
          {
            geometry: { coordinates: [-85.21128752393476, 29.69883536800688], type: "Point" },
            properties: { title: "CR 30-A", type: "area", name: "CR 30-A" }, type: "Feature"
          },
          {
            geometry: { coordinates: [-85.24393953089732, 29.678483724271832], type: "Point" },
            properties: { title: "Indian Pass", type: "area", name: "Indian Pass" }, type: "Feature"
          },
          {
            geometry: { coordinates: [-84.99355740046187, 29.725659378420165], type: "Point" },
            properties: { title: "Apalachicola", type: "area", name: "Apalachicola" }, type: "Feature"
          },
          {
            geometry: { coordinates: [-84.66250104126522, 29.853938515432244], type: "Point" },
            properties: { title: "Carrabelle", type: "area", name: "Carrabelle" }, type: "Feature"
          },
          {
            geometry: { coordinates: [-84.87990522495605, 29.658337302528803], type: "Point" },
            properties: { title: "St. George Island", type: "area", name: "St. George Island" }, type: "Feature"
          },
          {
            geometry: { coordinates: [-85.41878385307308, 29.949341060677252], type: "Point" },
            properties: { title: "Mexico Beach", type: "area", name: "Mexico Beach" }, type: "Feature"
          },
          {
            geometry: { coordinates: [-84.89269629913551, 29.73739588836201], type: "Point" },
            properties: { title: "Eastpoint", type: "area", name: "Eastpoint" }, type: "Feature"
          },
          {
            geometry: { coordinates: [-84.60378242176056, 29.805864533317003], type: "Point" },
            properties: { title: "Dog Island", type: "area", name: "Dog Island" }, type: "Feature"
          },
          {
            geometry: { coordinates: [-85.19933250469572, 30.114925837671496], type: "Point" },
            properties: { title: "Wewahitchka", type: "area", name: "Wewahitchka" }, type: "Feature"
          },
          {
            geometry: { coordinates: [-85.16050872987029, 30.005615270706745], type: "Point" },
            properties: { title: "Dalkeith", type: "area", name: "Dalkeith" }, type: "Feature"
          },
          {
            geometry: { coordinates: [-85.3404289882144, 29.861501178496827], type: "Point" },
            properties: { title: "WindMark Beach", type: "area", name: "WindMark Beach" }, type: "Feature"
          },
          {
            geometry: { coordinates: [-85.36948038771197, 29.90814378730305], type: "Point" },
            properties: { title: "St. Joe Beach", type: "area", name: "St. Joe Beach" }, type: "Feature"
          },
          {
            geometry: { coordinates: [-85.22233412437747, 29.882845598358475], type: "Point" },
            properties: { title: "White City", type: "area", name: "White City" }, type: "Feature"
          },
        ]
      },
      association: 'rafgc',
      params: {},
      meta: {},
      noresults: false,
      activeMls: {},
      numFavorites: localStorage.getItem('favorites') ? JSON.parse(localStorage.getItem('favorites')).length : 0
    }
  },

  computed: {
    query () {
      let query = '?q=search'
      this.params.latitude = '29.577546640745005|30.233106258983756'
      this.params.longitude = '-84.50283175057893|-85.48682166875159'
      this.params.association = this.association

      for (const value in this.params) {
        query +=  this.params[value] != '' && this.params[value] != null && this.params[value] != undefined ? '&' + value + '=' + this.params[value] : ''
      }
      return query
    }
  },

  mounted () {
    if(this.terms != {}){
      this.params = this.terms
    }

    if (!localStorage.favorites) {
      localStorage.favorites = JSON.stringify([])
    }

    if(this.params.region || this.params.omni){
      this.requestData()
    }

    var paused = window.localStorage.getItem('paused')
    if (paused === 'true'){
      localStorage['paused'] = 'false'
    }
  },

  methods: {
    updateFavorites () {
      this.numFavorites = JSON.parse(localStorage.getItem('favorites')).length
    },

    performSearch (data) {
      this.params = data.params
      this.requestData()
    },

    performFilter (data) {
      if(data.params.propertyType){
        this.params.propertyType = data.params.propertyType
      }
      if(data.params.region){
        this.params.region = data.params.region
      }
      this.requestData()
    },

    filterArea (data) {
      if(data.region){
        this.params.region = data.region
      }
      this.requestData()
    },

    toggleSortFilter () {
      this.showSort = !this.showSort
    },

    setActiveListing (data) {
      fetch('https://rets.kerigan.com/api/v2/listing/' + data.mls, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(r => r.json())
        .then(response => {
          this.activeMls = response.data
        })

    },

    requestData () {
      this.listings = []
      this.loading = true

      fetch(this.endpoint + this.query, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(r => r.json())
        .then(response => {
            this.geojson = response

            if(this.geojson.features.length == 0){
              this.noresults = true
            } else {
              this.meta.total = this.geojson.features.length
              this.noresults = false
            }

            this.showAreas = false
            this.loading = false
        });
    }
  },

  components: {
    PropertySearchForm,
    SearchFilters,
    ListingCard,
    MapSearchMap
  }
}
</script>
